'use client';

import { createContext, useContext } from 'react';
import { ToastType } from '@headless-workspace/glow-ds';

export type Toast = {
    label: React.ReactNode;
    type: ToastType;
    options?: {
        animation?: boolean;
        persistent?: boolean;
        duration?: number;
        canClose?: boolean;
        hasModalFooter?: boolean;
    };
    isLeaving?: boolean;
};
export interface ToastWithTimer extends Toast {
    timer?: NodeJS.Timeout;
}
interface ToastActionsContext {
    showToast: (toast: Toast) => void;
    closeToast: () => void;
}

interface ToastStateContext {
    toast?: ToastWithTimer;
}

export const ToastActionsContext = createContext<ToastActionsContext>({
    showToast: () => '',
    closeToast: () => null,
});
export const ToastStateContext = createContext<ToastStateContext>({ toast: undefined });

export const useToastActionsContext = () => useContext(ToastActionsContext);
export const useToastStateContext = () => useContext(ToastStateContext);
